import { KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { Box, MenuItem, Pagination, PaginationItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { paginationButton, paginationContainer, paginationItem, rowsPerPageSelect } from './CustomPaginationStyles'

type CustomPaginationProps = {
  total: number | undefined
  limit: number
  page: number
  onPageChange: (event: React.ChangeEvent<unknown>, newPage: number) => void
  onLimitChange: (event: SelectChangeEvent<number>, child: React.ReactNode) => void
  handlePrefetch: () => void
}

const CustomPagination = ({
  total,
  limit,
  page,
  onPageChange,
  onLimitChange,
  handlePrefetch,
}: CustomPaginationProps) => {
  const { t } = useTranslation('general')

  if (!total || total <= 25) {
    return null
  }

  const totalPages = Math.ceil(total / limit)

  return (
    <Box sx={paginationContainer}>
      <Typography variant="body2">{t('rowsPerPage')}</Typography>
      <Select value={limit} onChange={onLimitChange} sx={rowsPerPageSelect} IconComponent={KeyboardArrowDown}>
        <MenuItem value={25}>25</MenuItem>
        <MenuItem value={50}>50</MenuItem>
        <MenuItem value={100}>100</MenuItem>
      </Select>
      <Pagination
        count={totalPages}
        page={page}
        onChange={onPageChange}
        shape="rounded"
        renderItem={(item) => (
          <PaginationItem
            page={item.page}
            type={item.type}
            selected={item.selected}
            disabled={item.disabled}
            onClick={item.onClick}
            onMouseEnter={handlePrefetch}
            sx={item.type === 'previous' || item.type === 'next' ? paginationButton : paginationItem}>
            {item.type === 'previous' && (
              <>
                <KeyboardArrowLeft onMouseEnter={handlePrefetch} /> {t('previous')}
              </>
            )}
            {item.type === 'next' && (
              <>
                {t('next')} <KeyboardArrowRight onMouseEnter={handlePrefetch} />
              </>
            )}
          </PaginationItem>
        )}
      />
    </Box>
  )
}

export default CustomPagination
